import { CustomIconProps } from './art';

export const ProfileCloudMidIcon = (props: CustomIconProps): JSX.Element => (
  <svg width="102" height="46" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M86.638 14.909c8.095.03 14.643 4.498 14.635 9.997-.009 5.51-6.596 9.966-14.713 9.954a21.521 21.521 0 0 1-3.087-.225c-.869 4.442-5.75 7.861-11.662 7.893-3.985.022-7.519-1.501-9.68-3.854-3.73 4.054-10.053 6.739-17.238 6.778-8.672.047-16.13-3.773-19.309-9.25-2.082 1.587-4.733 2.536-7.62 2.532-5.562-.008-10.243-3.554-11.652-8.378C2.842 29.973.119 27.46.004 24.32c-.128-3.507 3.042-6.47 7.08-6.617a8.18 8.18 0 0 1 3.455.614C12.596 16.8 15.186 15.9 18 15.905c.434 0 .864.022 1.287.065 2.035-3.614 6.07-6.072 10.712-6.065.422 0 .839.021 1.25.061C34.19 4.19 41.792.05 50.728 0 57.881-.038 64.208 2.555 67.99 6.54a16.789 16.789 0 0 1 4.607-.63c6.615.01 12.204 3.798 14.04 9Z"
      fill="#ABD6F3"
    />
  </svg>
);
